import React from "react";
import classes from "./menu.module.scss";
import { withRouter, useLocation } from "react-router";
import { isNil } from "lodash";
import cn from "classnames";

const Menu = ({ pages, history, id, width, containerClassname }) => {
  const location = useLocation();
  return (
    <>
      <div
        className={cn(
          containerClassname && containerClassname,
          classes.menuContainer
        )}
      >
        <div className={classes.menuWrapper} style={{ width: width && width }}>
          {pages.map((item) => (
            <span
              onClick={() => {
                if (!isNil(id)) {
                  history.push(`${item.pathName}?id=${id}`);
                } else {
                  history.push(`${item.pathName}`);
                }
              }}
              className={
                item.path === `${location.pathname.split("-")[2]}`
                  ? classes.menuItem
                  : classes.inActiveMenuItem
              }
            >
              {item.title}
            </span>
          ))}
        </div>
        <div className={classes.divider} />
      </div>
    </>
  );
};

export default withRouter(Menu);
